import { render, staticRenderFns } from "./TabelaTerritoriosInseridosRevenda.vue?vue&type=template&id=c4215dce&lang=pug"
import script from "./TabelaTerritoriosInseridosRevenda.vue?vue&type=script&lang=js"
export * from "./TabelaTerritoriosInseridosRevenda.vue?vue&type=script&lang=js"
import style0 from "./TabelaTerritoriosInseridosRevenda.vue?vue&type=style&index=0&id=c4215dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports